import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';

const PIXEL_ID = '1594188608482446';

const initPixel = () => {
    if (window.fbq) return;

    const pixelFn = function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    };

    pixelFn(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
};

export default function MetaPixel() {
    const [consented, setConsented] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // If user already consented in a previous visit, init immediately
        return 
        if (getCookieConsentValue('aome_cookie_consent') === 'true') {
            initPixel();
            setConsented(true);
        }
    }, []);

    const handleAccept = () => {
        return 
        initPixel();
        setConsented(true);
    };

    // const showBanner = ["/", "/signup", "/login", 
    //     "/faq", "/privacy-policy", "/terms-of-service", "/commerce-disclosure"].includes(location.pathname);
    const showBanner = false

    return (
        <>
            {/* noscript fallback — only render after consent */}
            {consented && (
                <noscript>
                    <img
                        height="1" width="1" style={{ display: 'none' }}
                        src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
                        alt=""
                    />
                </noscript>
            )}

{showBanner && (
            <CookieConsent
                cookieName="aome_cookie_consent"
                onAccept={handleAccept}
                onDecline={() => { }}
                enableDeclineButton
                buttonText="受け入れる"
                declineButtonText="断る"
                style={{
                    background: '#FFFFFF40',
                    fontSize: '12px',
                    fontWeight: '300',
                    color: "#4B4A49",
                    backdropFilter: "blur(4px)",
                    WebkitBackdropFilter: "blur(4px)",
                    boxShadow: "0 -4px 4px rgba(35, 43, 103, 0.03)",
                    padding: '8px 12px',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                }}
                contentStyle={{
                    margin: '0',
                    flex: '1',
                }}
                buttonWrapperClasses="flex gap-1 flex-shrink-0"
                buttonStyle={{
                    background: '#27485C',
                    color: '#fff',
                    borderRadius: '10px',
                    padding: '6px 10px',
                    fontSize: '12px',
                    margin: '0',
                    whiteSpace: 'nowrap',
                }}
                declineButtonStyle={{
                    background: '#FFFFFF80',
                    color: '#4B4A49CC',
                    borderRadius: '10px',
                    padding: '6px 30px',
                    fontSize: '12px',
                    margin: '0',
                    whiteSpace: 'nowrap',
                }}
            >
                Cookieを使用しています。
            </CookieConsent>
             )}
        </>
    );
}